export default "__VITE_ASSET__DDNJlkMH__"